var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToggleSpecial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.149,
    height: 18.204,
    viewBox: "578.715 95.898 9.149 18.204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M578.715 109.381c0 2.648 2.002 4.722 4.558 4.722 2.574 0 4.59-2.074 4.59-4.722 0-2.638-2.016-4.704-4.59-4.704-2.556 0-4.558 2.066-4.558 4.704m7.401 0",
    fill: "#fc7d7d",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.62 99.594v4.77a.188.188 0 0 0 .32.133 4.62 4.62 0 0 1 3.32-1.383c1.28 0 2.471.493 3.355 1.388a.188.188 0 0 0 .32-.133v-4.775c0-2.038-1.64-3.696-3.658-3.696-2.017 0-3.657 1.658-3.657 3.696",
    fill: "#6f6f6f",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6467"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleSpecial);
export default __webpack_public_path__ + "static/media/toggleSpecial.00e8786ebad0e4f6ac3bd0d8686adc8c.svg";
export { ForwardRef as ReactComponent };